import { ICaseExtInfo } from "../../common";
import { wasmModule } from "../wasm/wasmModule";

class TreatmentPlan {
  private _currentTx = "Treatment_1";
  private _currentTxIndex = 1;
  private _caseExtInfo: ICaseExtInfo;

  get caseExtInfo() {
    return this._caseExtInfo;
  }

  get currentTx() {
    return this._currentTx;
  }

  get currentTxIndex() {
    return this._currentTxIndex;
  }

  setCaseExtInfo(caseExtInfo: ICaseExtInfo) {
    this._caseExtInfo = caseExtInfo;
  }

  /**
   * Get treatment plan name list
   * @returns
   */
  getTxNameList() {
    const ret = [wasmModule.stagingcontoler.GetTXName(1)];
    if (wasmModule.stagingcontoler.Tx2Exist()) {
      ret.push(wasmModule.stagingcontoler.GetTXName(2));
    }
    return ret;
    // return treatmentPlan.caseExtInfo.case_extra_attrs.TreatmentPlanNames;
  }

  /**
   * change current tx to another
   * @param txName
   * @returns
   */
  changeTx(txName: string) {
    if (this._currentTx === txName) {
      return false;
    }
    const txIndex = this._getNameIndex(txName);
    this._currentTxIndex = txIndex;
    wasmModule.stagingcontoler.ChangeTreatment(txIndex);
    this._currentTx = wasmModule.stagingcontoler.GetTXName(txIndex);

    console.log("changeTx::", txName, `current Tx::${this._currentTx}`);

    return true;
  }

  /**
   * del a tx plan
   * @param txName the tx plan name
   * @returns
   */
  delTx(txName: string) {
    console.log("del::", this._currentTx, txName);
    if (this._currentTx === txName) {
      console.log(`Can't del the current TxPlan.`);
      return false;
    }
    const txIndex = this._getNameIndex(txName);
    if (txIndex == 2) {
      if (wasmModule.stagingcontoler.Tx2Exist()) {
        const ret = wasmModule.stagingcontoler.DelTx(2);
        console.log(`Del Treatment index ${txIndex} done:`, ret);
      }
    }

    if (txIndex == 1) {
      const ret = wasmModule.stagingcontoler.DelTx(1);
      console.log(`Del Treatment index ${txIndex} done:`, ret);
    }
  }

  saveCurrentTx() {
    return wasmModule.stagingcontoler.SaveCurTx();
  }

  /**
   * renameTx
   * @param txName old name
   * @param newName new name
   * @returns
   */
  renameTx(txName: string, newName: string) {
    // console.log('the function is in development')
    // const nameList = treatmentPlan.caseExtInfo.case_extra_attrs.TreatmentPlanNames;
    // const index = nameList.findIndex((val)=>{
    //   return val === txName
    // });
    // if (index === -1) {
    //   return false
    // }
    // nameList[index] = newName;
    const txIndex = this._getNameIndex(txName);
    if (this._currentTx === txName) {
      this._currentTx = newName;
    }
    return wasmModule.stagingcontoler.RenameTX(txIndex, newName);
  }

  copyTx() {
    console.log("the function is in development");
    return true;
  }

  _getNameIndex(txName: string) {
    if (txName === wasmModule.stagingcontoler.GetTXName(1)) {
      return 1;
    }
    if (txName === wasmModule.stagingcontoler.GetTXName(2)) {
      return 2;
    }
    return 0;
  }
}

export const treatmentPlan = new TreatmentPlan();
